import { render, staticRenderFns } from "./ViewFilesTable.vue?vue&type=template&id=76906d1e"
import script from "./ViewFilesTable.vue?vue&type=script&lang=js"
export * from "./ViewFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports